// Vendor Libs
import React, {useState} from 'react';

// Dish Tech React
import {CheckAuthSession} from '@dishtech-react/core';

// Material UI
import {Button} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

// Components
import Layout from './Layout';
import Table from './Table';
import Edit from './Edit';

// hooks
import useFetch from '../hooks/useFetch';

// Styles
import '../styles/app.scss';

export interface IItem {
    name: string
    type: string
    expire: number
    data: {
        [index: string]: string;
    }
}

export default () => {
    const {data, error, loading, update} = useFetch(`/api/kms/v1/management`)
    const [editObject, setEditObject] = useState<IItem | null>(null);
    const [dialogOpen, setDialogIsOpen] = useState<boolean>(false);
    const closeDialog = () => {
        setDialogIsOpen(false)
        setEditObject(null);
    }
    return (
        <Layout>
            <CheckAuthSession/>
            <Edit update={update} isOpen={dialogOpen} close={closeDialog} edit={editObject}/>
            <div style={{textAlign: 'right', margin: '0 0 1rem'}}>
                <Button variant="contained" onClick={() => setDialogIsOpen(true)} color="primary" component="span">Create
                    New</Button>
            </div>
            {error && <Alert style={{marginBottom: '1rem'}} severity="error" action={
                <Button color="inherit" size="small">
                    Retry
                </Button>
            }>{error.message}</Alert>}
            <Table refresh={update} rows={data || []} isLoading={loading} setEditObject={(obj: IItem) => {
                setEditObject(obj);
                setDialogIsOpen(true);
            }}/>
        </Layout>
    );
};
